import styled from 'styled-components';
export const SelectContainer = styled.div `
  --border-color: ${props => {
    if (props.disabled) {
        return props.theme.input.borderColors.default;
    }
    if (props.error) {
        return props.theme.input.borderColors.error;
    }
    if (props.opened) {
        return props.theme.input.borderColors.focus;
    }
    return props.theme.input.borderColors.default;
}};
  display: block;
  ${props => props.disabled && 'cursor: not-allowed;'}
  ${props => props.minWidth && `min-width: ${props.minWidth};`}
  user-select: none;
  position: relative;
`;
export const SelectLabel = styled.label `
  font-size: 14px; 
  padding: 0 5px 0 5px;
  line-height: 16px;
  color: #000;
  font-weight: 600;
  position: absolute;
  top: 0;
  left: 5px;
  z-index: 2;
  background-color: ${props => props.theme.input.normal.backgroundColor};
  transform: translateY(-50%);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 95%;
`;
export const SelectWrapper = styled.div `
  display: flex;
  align-items: center;
  position: relative;
`;
export const SelectTrigger = styled.div `
  box-sizing: border-box;
  height: 42px;
  display: flex;
  align-items: center;
  position: relative;
  border: 1px solid;
  width: 100%;
  cursor: pointer;
  ${props => !props.error && `
    &:not([disabled]):hover {
      border: 1px solid ${props.theme.input.borderColors.hover};
    }
  `}
  background: ${props => props.theme.input[props.disabled ? 'disabled' : 'normal'].backgroundColor};
  color: ${props => props.theme.input[props.disabled ? 'disabled' : 'normal'].textColor};
  border: 1px solid var(--border-color);
  svg {
    fill: ${props => props.theme.input[props.disabled ? 'disabled' : 'normal'].selectArrowColor};
  }
`;
export const SelectContentWrapper = styled.div `
  display: flex;
  flex-flow: column;
  position: absolute;
  z-index: 20;
  background-color: #FFF;
  border: 1px solid var(--border-color);
  border-top-color: ${props => props.theme.input.borderColors.default};
  width: 100%;
  top: 42px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  clip: rect(0, 9999px, 9999px 0);
`;
export const SelectContent = styled.div `
  display: flex;
  flex-flow: column;
  max-height: 300px;
  overflow: auto;
  font-weight: medium;
`;
export const SelectContentOptionsWrapper = styled.div `
  display: flex;
  flex-flow: column;
  padding: 5px 0;
`;
export const InputErrorTooltipContainer = styled.div `
  padding-right: 10px;
`;
export const InputErrorTooltipMobileContainer = styled.div `
  position: absolute;
  right: 40px;
  top: 10px;
`;
export const IconsWrapper = styled.div `
  display: flex;
`;
export const IconButton = styled.div `
  padding-right: 10px;
  svg {
    fill: #000;
  }
`;
export const SelectPlaceholderContainer = styled.div `
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;
export const SelectPlaceholderWrapper = styled.div `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  padding: 10px;
`;
export const SelectPlaceholder = styled.div `
  display: inline-block;
  z-index: 0;
  text-transform: lowercase;
  ${props => props.selected && !props.floating && 'display: none;'}
  font-size: ${props => props.floating && props.selected ? '14px' : 'inherit'};
  background-color: ${props => props.theme.input[props.disabled ? 'disabled' : 'normal'].backgroundColor};
  position: ${props => props.floating && props.selected ? 'absolute' : 'relative'};
  top: ${props => props.floating && props.selected ? '-12px' : 'unset'};
  left: ${props => props.floating && props.selected ? '5px' : 'unset'};
  padding: ${props => props.floating && props.selected ? '0 5px' : 'unset'};
  color: ${props => props.disabled ? props.theme.input.disabled.placeholderTextColor : (props.placeholderColor ? props.placeholderColor : props.theme.input.normal.placeholderTextColor)};
  font-weight: 500;
`;
export const SelectOptionWrapper = styled.div `
  display: flex;
  flex-flow: row;
  align-items: center;
  line-height: 18px;
  padding: 5px 10px;
  border: none;
  color: #000;
  font-weight: medium;
  cursor: pointer;
  &:hover { 
    ${props => !props.disabled ? `color: ${props.theme.colors.primary}` : ''} 
  }
  &[disabled] { 
    color: ${props => props.theme.colors.disabled};
    cursor: not-allowed;
    opacity: .5;
  }
`;
export const NoOptionsPlaceholder = styled.div `
  color: black;
  padding: .5rem 1rem;
`;
export const SelectMobileContainer = styled.div `
  display: block;
  position: relative;
  min-width: 70px;
`;
export const SelectMobileComponent = styled.select `
  font-size: 14px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  ${props => props.disabled && 'cursor: not-allowed;'};
  user-select: none;
  padding: 11px 10px;
  outline: none;
  background: ${props => props.theme.input[props.disabled ? 'disabled' : 'normal'].backgroundColor};
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  width: 100%;
  &:required:invalid {
    color: gray;
  }
  ${props => props.clearable ? 'padding-right: 6rem' : 'padding-right: 3rem'};
`;
export const SelectMobileWrapper = styled.div `
  display: flex;
  align-items: center;
  --border-color: ${props => {
    if (props.disabled) {
        return props.theme.input.borderColors.default;
    }
    if (props.error) {
        return props.theme.input.borderColors.error;
    }
    if (props.opened) {
        return props.theme.input.borderColors.focus;
    }
    return props.theme.input.borderColors.default;
}};
  border: 1px solid var(--border-color);
`;
export const SelectMobileIcon = styled.div `
  padding: 1rem;
  cursor: pointer;
  transform: rotateZ(270deg);
  padding: 0;
  pointer-events: ${props => props.active ? 'all' : 'none'};
  &:last-of-type {
    padding-left: 0;
  }
`;
export const SelectMobileIconWrapper = styled.div `
  height: 100%;
  position: absolute;
  right: 6px;
  top: 0;
  height: 40px;
  display: flex;
  align-items: center;
  flex-flow: row nowrap;
  pointer-events: none;
`;
export const SelectMultipleButtonsContainer = styled.div `
  padding: 5px;
  display: flex;

  > :first-child {
    margin-right: 3px;

    & + * {
      margin-left: 2px;
    }
  }
`;
